// Export bridge to maintain backward compatibility
import DLOScheduleSetting from './DLOScheduleSetting/index';
export default DLOScheduleSetting;
